import "./style.css";

const ProjectCard = ({ image, name, description }) => {
  return <div className="project-card"></div>;
};

export default ProjectCard;
